<template>
  <div>
    <div v-if="currentUser.isAdmin">
      <div class="row d-flex align-items-center mt-5">
        <div class="col-sm-6">
          <h4>OVP darba apstākļi</h4>
        </div>
        <div class="col-sm-6 d-flex justify-content-around">
          <OvpJobConditionsAdd />
        </div>
      </div>
      <OvpJobConditionList :hasSearch="true" />
      <div class="col-sm-6 mb-3 px-0 mt-5">
        <h4>OVP darba apstākļi amatiem</h4>
      </div>

      <OvpByJobTitle />
    </div>
    <UsersOvpJobConditions />
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { SkeletonLoaderRepository } from "../global/skeleton-loader/SkeletonLoaderRepository";

import OvpJobConditionsAdd from "./OvpJobConditionsAdd";
import OvpJobConditionList from "./OvpJobConditionList";
import UsersOvpJobConditions from "./users/UsersOvpJobConditions";
import OvpByJobTitle from "../job-titles/OvpByJobTitle";
import * as companyStoreTypes from "../../vuex/modules/company/company.store-types";
import * as authStoreTypes from "../../vuex/modules/auth/auth.store-types";

export default {
  name: "ovp-job-conditions",
  components: {
    OvpJobConditionList,
    OvpJobConditionsAdd,
    OvpByJobTitle,
    UsersOvpJobConditions,
  },
  data: () => ({ skeletonData: SkeletonLoaderRepository.usersListLayout }),
  async created() {
    const companyId = this.currentUser.isAdmin
      ? this.$route.params.companyId
      : this.currentUser.company._id;
    const currentCompany = await this.getSingleCompany(companyId);

    if (!currentCompany._id) {
      this.$router.push({ name: "index" });
    }
  },
  computed: {
    ...mapGetters("company", {
      /** @type {Company|*} */
      currentCompany: companyStoreTypes.GET_CURRENT_COMPANY,
      /** @type {boolean|*} */
      isLoading: companyStoreTypes.GET_IS_LOADING,
    }),
    ...mapGetters("auth", {
      /** @type {CurrentUser|*} */
      currentUser: authStoreTypes.GET_CURRENT_USER,
    }),
  },
  methods: {
    ...mapActions("company", {
      /** @type {function|*} */
      getSingleCompany: companyStoreTypes.ACTION_GET_SINGLE_COMPANY,
    }),
  },
};
</script>